<template>
  <div id="resetpassword">
    <Header />
    <section id="resetpassword__content">
      <BlockTitle title="重新设置密码" />
      <div id="resetpassword__byEmail">
        <template v-if="resetPasswordLayout === 'isNormal'">
          <label for="reset_user_password" :class="{'invalid': isInValidPassword}">
            <div class="label_title">密码<span>*6~12個字，需英數混合</span></div>
            <div class="label_input">
              <input 
                id="reset_user_password" 
                :type="passwordType" 
                v-model="password" 
                @blur="handlePassword">
              <div class="eye" @click="handleSeePassword('password')">
                <i :class="`icon-eye_${eyePasswordType}`"></i>
              </div>
            </div>
          </label>

          <label for="reset_user_check_password" :class="{'invalid': isInValidCheckPassword}">
            <div class="label_title">再次确认密码<span>請與密碼相同</span></div>
            <div class="label_input">
              <input 
                id="reset_user_check_password" 
                :type="passwordCheckType"
                v-model="check_password" 
                @blur="handleCheckPassword">
              <div class="eye" @click="handleSeePassword('checkpassword')">
                <i :class="`icon-eye_${eyeCheckPasswordType}`"></i>
              </div>
            </div>
            
          </label>

          <div class="btns submit">
            <div class="btn submit" @click="handleSubmit">确认</div>
          </div>
        </template>
        <template v-if="resetPasswordLayout === 'isError'">
          <div class="desc error">密码设置失败!</div>
          <div class="btns">
            <div class="btn" @click="reset">重新设置</div>
          </div>
        </template>

        <template v-if="resetPasswordLayout === 'isSuccess'">
          <div class="desc">密码设置成功!</div>
          <div class="btns">
            <div class="btn" @click="goLogin">登入</div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import { 
  mapGetters,
  mapActions,
} from 'vuex';

// @ is an alias to /src
import Header from "@/components/Header.vue";
import BlockTitle from "@/components/BlockTitle.vue";

export default {
  name: "resetpassword",
  components: {
    Header,
    BlockTitle
  },
  data() {
    return {
      isInValidPassword: false,
      isInValidCheckPassword: false,

      password: '',
      check_password: '',

      passwordType: 'password', // password, text
      passwordCheckType: 'password', // password, text

      redirect_uri: ''
    }
  },
  computed: {
    ...mapGetters([
      'resetPasswordLayout'
    ]),

    eyePasswordType() {
      switch (this.passwordType) {
        case 'password':
          return 'close'
          break;
        case 'text':
          return 'open'
          break;
      }
    },

    eyeCheckPasswordType() {
      switch (this.passwordCheckType) {
        case 'password':
          return 'close'
          break;
        case 'text':
          return 'open'
          break;
      }
    }
  },
  methods: {
    ...mapActions([
      'resetPassword',
      'setResetPasswordLayout'
    ]),

    handlePassword() {
      if (this.password === '') {
        this.isInValidPassword = true
        return 
      }
      
      this.isInValidPassword = !/^(?=.*\d)(?=.*[a-zA-Z]).{6,12}$/.test(this.password)
    },

    handleCheckPassword() {
      if (this.check_password === '' || this.password === '') {
        this.isInValidCheckPassword = true
        return 
      }

      this.isInValidCheckPassword = !(this.check_password === this.password)
    },

    handleSeePassword(type) {
      if (type === 'checkpassword') {
        this.passwordCheckType === 'password'
        ? this.passwordCheckType = 'text'
        : this.passwordCheckType = 'password'
      } else {
        this.passwordType === 'password'
        ? this.passwordType = 'text'
        : this.passwordType = 'password'
      }
    },

    handleSubmit() {
      this.handlePassword()
      this.handleCheckPassword()

      if (
        this.isInValidPassword === false && 
        this.isInValidCheckPassword === false
      ) {
        let formData = new FormData()

        formData.append('password', this.password)

        this.resetPassword({
          formData
        })
      }
    },

    reset() {
      this.setResetPasswordLayout({
        layout: 'isNormal'
      })

      this.isInValidPassword = false,
      this.isInValidCheckPassword = false,

      this.password = '',
      this.check_password = '',

      this.redirect_uri = ''
    },

    goLogin() {
      this.$router.push({ name: 'login', query: {'app_id': window.app_id, 'redirect_uri': this.redirect_uri} })
    }
  }
};
</script>
